import { render, staticRenderFns } from "./TaskChangeStatus.vue?vue&type=template&id=44ca42dd&scoped=true&lang=pug&"
import script from "./TaskChangeStatus.vue?vue&type=script&lang=js&"
export * from "./TaskChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./TaskChangeStatus.vue?vue&type=style&index=0&id=44ca42dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca42dd",
  null
  
)

export default component.exports